import { fetchUtils } from 'react-admin';
import Cookies from './Cookies'

const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
   
    const token = Cookies.getCookie('gcPortalToken')
    options.headers.set('Authorization', `Bearer ${token}`);
    return fetchUtils.fetchJson(url, options);
  }

  export default httpClient;